import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import VirtualBrand from './VirtualBrand';

export interface Result {
	items: VirtualBrand[];
}

export default async function findVirtualBrands(client: ApiClient, filter: string): Promise<Result> {
	const url = parseTemplate('analytics/autocomplete/virtual-brands{?filter}');
	const request = await client.fetch(url.expand({ filter }));
	const response = await request.json();
	return { items: response.items.map((item: { name: string }) => new VirtualBrand(item.name)) };
}
